// Standard five-field cron (https://en.wikipedia.org/wiki/Cron): minute, hour,
// day of month, month, day of week. Nonstandard extensions (seconds, @macros,
// L, W, #, ?) are refused, as is a step on a single value.

const MONTHS = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
const DAYS = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];

const FIELDS = [
  {min: 0, max: 59},
  {min: 0, max: 23},
  {min: 1, max: 31},
  {min: 1, max: 12, names: MONTHS, firstName: 1},
  {min: 0, max: 6, names: DAYS, firstName: 0},
];

export const normalizeCronExpression = expression =>
  String(expression ?? '').trim().split(/\s+/).filter(Boolean).join(' ');

const valueOf = (token, field) => {
  if (/^\d+$/.test(token)) {
    const n = +token;
    return n >= field.min && n <= field.max ? n : null;
  }
  // ASCII only: Unicode case mapping turns look-alikes such as 'ſun' into 'SUN'.
  if (!field.names || !/^[A-Za-z]{3}$/.test(token)) return null;
  const index = field.names.indexOf(token.toUpperCase());
  return index >= 0 ? index + field.firstName : null;
};

const isValidItem = (item, field) => {
  const [base, step, ...rest] = item.split('/');
  if (rest.length || (step !== undefined && !(/^\d+$/.test(step) && +step >= 1))) return false;
  if (base === '*') return true;
  const bounds = base.split('-');
  if (bounds.length === 1) return step === undefined && valueOf(base, field) !== null;
  if (bounds.length !== 2) return false;
  const [from, to] = bounds.map(bound => valueOf(bound, field));
  return from !== null && to !== null && from <= to;
};

export function isValidCronExpression(expression) {
  const fields = normalizeCronExpression(expression).split(' ');
  if (fields.length !== FIELDS.length) return false;
  return fields.every((field, i) => field.split(',').every(item => isValidItem(item, FIELDS[i])));
}
